import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  dial(event) {
    event.preventDefault()

    const detail = {
      phoneNumber: this.element.dataset.phoneNumber,
      countryCode: this.element.dataset.countryCode,
      contactId: this.element.dataset.contactId
    }

    window.dispatchEvent(new CustomEvent('zencall:dial', { detail }))
  }
}
